<div class="sourceBlock d-inline-flex align-items-center mb-2" (click)="openSourceModal.emit()">
    <span>
        @if ((sources() || []).length > 0) {
            @for (source of sources()?.slice(0,3); track $index) {
              <i [class.default]="source.image && source.image.includes('default-logo')">
                <img [src]="source.image" alt="Site Logo" />
              </i>
            }
        }
    </span>
    <div class="ms-1">Sources</div>
</div>